import React, { useEffect } from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";

// @mui/material components
import { Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText } from "@mui/material";

// core components
import Button from "components/button/button";
import Loader from '../../configuration/components/loader';

// actions
import { deleteSelection } from "actions/category/deleteSelection";

function GlobalDeleteDialog(props) {
    const { categories, closeDialog, deleted, loading, isOpen } = props;

    useEffect(() => {
        if (deleted) {
            closeDialog();
        }
    }, [deleted]);

    return (
        <Dialog
            open={isOpen}
            onClose={closeDialog}
            maxWidth={'xs'}
            scroll={'body'}
        >
            <DialogTitle>
                <FormattedMessage id={"category.global.delete.title"} />
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <FormattedMessage id={"category.global.delete.text"} />
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button color={"info"} simple onClick={closeDialog} disabled={loading}>
                    <FormattedMessage id={"category.delete.cancel"} />
                </Button>
                <Button
                    round
                    color={"danger"}
                    type="submit"
                    disabled={loading}
                    onClick={() => props.deleteSelection(categories)}
                >
                    <FormattedMessage id={"category.delete.submit"} />
                    {loading && <Loader />}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

const mapStateToProps = state => {
    return {
        loading: state.category.deleteSelection.loading,
        deleted: state.category.deleteSelection.deleted,
    }
};

const mapDispatchToProps = dispatch => ({
    deleteSelection: (categories) => dispatch(deleteSelection(categories)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GlobalDeleteDialog);
